import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  constructor(private spinner: NgxSpinnerService) { }

  public showSpinner() {
    this.spinner.show(undefined,
      {
        type: 'square-spin',
        size: 'medium',
        bdColor: 'rgba(255,255,255, .5)',
        color: '#005440',
        fullScreen: false,
      }
    );
  }

  public hideSpinner() {
    setTimeout(() => { this.spinner.hide() }, 500);
  }
}
